export function sendToRdStationLoginTriggerSearch(data) {
  return fetch('https://www.rdstation.com.br/api/1.3/conversions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: "Bearer 904297ddf27aa488461f1936e94791d6",
    },
    body: JSON.stringify({
      token_rdstation: '904297ddf27aa488461f1936e94791d6',
      identificador: 'sp_login',
      email: data.email,
      nome: data.name,
      searchParams: data.searchParams,
      departureDate: data.departureDate,
      returnDate: data.returnDate,
    }),
  });
}

export function triggerRdStationVerify(newData) {
  if (!newData) return;
  const storedDataRaw = localStorage.getItem('lastLoginTriggerSearch');
  const storedData = storedDataRaw ? JSON.parse(storedDataRaw) : null;

  const isEqual = JSON.stringify(storedData) === JSON.stringify(newData);

  if (!isEqual) {
    localStorage.setItem('lastLoginTriggerSearch', JSON.stringify(newData));
    sendToRdStationLoginTriggerSearch(newData);
  }
}


// WEBPACK FOOTER //
// ./src/utils/rdstation.js